import React from 'react';
import Header from './Header';
import './DocumentNotFound.css';

const DocumentNotFound = () => {
  return (
    <div className="document-not-found">
      <Header />
      <div className="document-not-found__content">
        <h1>Документ не найден</h1>
        <p>Запрашиваемый документ не существует или у вас нет к нему доступа</p>
      </div>
    </div>
  );
};

export default DocumentNotFound; 
